import React from "react";
import { Link } from "react-router-dom";
// DAS-151: 버전 v1 고정 — 디자인 시안(V1/V2/V3) 전환 행 비활성화.
// 재활성화 시 아래 import와 시트 내 <VariantRow /> 렌더를 복원하고
// utils/variantState.js의 VERSION_LOCKED를 false로 변경한다.
// import { VariantContext } from "../../contexts/variant_context";
// import { VARIANTS } from "../../utils/variantState";

const MoreIcon = () => (
    <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
        <circle cx="5" cy="12" r="2" />
        <circle cx="12" cy="12" r="2" />
        <circle cx="19" cy="12" r="2" />
    </svg>
);

const LogoutIcon = () => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5 flex-shrink-0"
    >
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <path d="M16 17l5-5-5-5" />
        <path d="M21 12H9" />
    </svg>
);

// DAS-151: 버전 v1 고정 — 디자인 시안(V1/V2/V3) 전환 행 비활성화.
// 재활성화 시 아래 VariantRow 정의와 시트 내 렌더를 복원한다.

class MobileMoreSheet extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
        this.sheetRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        this.handleKeyDown = (e) => {
            if (e.key === 'Escape' && this.state.open) {
                this.setState({ open: false });
            }
        };
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleClickOutside = (e) => {
        if (this.state.open && this.sheetRef.current && !this.sheetRef.current.contains(e.target)) {
            this.setState({ open: false });
        }
    };

    toggle = () => this.setState(prev => ({ open: !prev.open }));

    close = () => this.setState({ open: false });

    render() {
        const { items, onLogout, activeKey } = this.props;
        const { open } = this.state;
        const isAnyActive = items.some(it => it.key === activeKey);

        return (
            <>
                {/* Trigger: 5번째 탭 버튼 */}
                <button
                    type="button"
                    onClick={this.toggle}
                    aria-label="더 보기"
                    className={`
                        relative flex flex-1 flex-col items-center justify-center gap-0.5
                        transition-colors duration-150 min-h-[44px]
                        ${isAnyActive ? "text-brand-light" : "text-content-muted"}
                    `}
                >
                    {isAnyActive && (
                        <span className="absolute top-0 left-1/2 -translate-x-1/2 h-[2px] w-8 rounded-b-full bg-brand" />
                    )}
                    <MoreIcon />
                    <span className="text-xs font-medium leading-tight">More</span>
                </button>

                {/* Bottom sheet */}
                {open && (
                    <>
                        {/* 배경 오버레이 */}
                        <div
                            className="fixed inset-0 z-50 bg-overlay animate-fade-in"
                            onClick={this.close}
                        />
                        {/* 시트 */}
                        <div
                            ref={this.sheetRef}
                            className="fixed bottom-0 left-0 right-0 z-50 bg-surface-card border-t border-surface-border rounded-t-2xl animate-slide-up pb-safe"
                        >
                            {/* 드래그 핸들 */}
                            <div className="flex justify-center pt-2 pb-1">
                                <div className="h-1 w-8 rounded-full bg-surface-border" />
                            </div>

                            {/* 메뉴 항목 */}
                            <nav className="px-3 py-2 space-y-1">
                                {items.map((item) => {
                                    const isActive = item.key === activeKey;
                                    const IconComp = item.icon;
                                    return (
                                        <Link
                                            key={item.key}
                                            to={item.to}
                                            onClick={this.close}
                                            className={`
                                                relative flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium
                                                transition-all duration-150 min-h-[44px]
                                                ${isActive
                                                    ? "bg-brand-subtle text-brand-light"
                                                    : "text-content-secondary hover:bg-surface-hover hover:text-content"
                                                }
                                            `}
                                        >
                                            {isActive && (
                                                <span className="absolute left-0 top-1/2 -translate-y-1/2 h-5 w-[3px] rounded-r-full bg-brand" />
                                            )}
                                            <IconComp className={`h-5 w-5 flex-shrink-0 ${isActive ? "text-brand-light" : ""}`} />
                                            <span>{item.label}</span>
                                        </Link>
                                    );
                                })}
                            </nav>

                            {/* DAS-151: 버전 v1 고정 — 디자인 시안 전환 행 비활성화 */}

                            {/* 로그아웃 */}
                            <div className="border-t border-surface-border px-3 py-2 mb-2">
                                <button
                                    type="button"
                                    onClick={() => { this.close(); onLogout(); }}
                                    className="flex w-full items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium min-h-[44px] text-content-secondary hover:bg-loss-subtle hover:text-loss transition-colors"
                                >
                                    <LogoutIcon />
                                    <span>Logout</span>
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }
}

export default MobileMoreSheet;
